<template>
  <div>
    <v-container>
      <v-col align="center" xs="auto" mb-4>
        <v-card style="height: 100%">
          <v-row>
            <v-col xs="12">
              <v-card-title>
                <h3 class="primary--text" style="width: 100%"
                  >Sign in with Google</h3
                >
              </v-card-title>
              <v-card-text>
                <GoogleSignin alwaysShowButton> </GoogleSignin>
              </v-card-text>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-container>
    <v-footer class="justify-center pl-0" inset app>
      <v-row justify="center">
        <img src="@assets/identity-logo.png" height="48px" />
        <v-col sm="12" class="text-center"
          >This app uses the Wyoming Identity System for Authentication</v-col
        >
      </v-row>
    </v-footer>
  </div>
</template>
<script>
// IMPORTED COMPONENT the @component is an alias configuration, you can read more about it
// here https://citycode.wyo.gov/#/tutorials/aliases
import GoogleSignin from '@components/login/google-signin'
import UNPWSignIn from '@components/login/unpw-signin'
import AccountActions from '@components/login/account-actions'
import { authComputed } from '@state/helpers'
import appConfig from '@src/app.config'
export default {
  page: {
    title: 'Log in',
    meta: [{ name: 'description', content: `Log in to ${appConfig.title}` }],
  },
  // COMPONENT INSTANCE
  components: {
    GoogleSignin,
    UNPWSignIn,
    AccountActions,
  },
  data: () => ({}),
  computed: {
    ...authComputed,
  },
}
</script>
<style scoped></style>

<style></style>
